import useFormatter, { getNameInitials } from "@/hooks/use-formatter.hook.ts";
import { ApiEmployeeShort, getEmployeeAvatarUrl } from "@/types/employees/employee.types.ts";
import { Avatar, AvatarSizes, AvatarVariant, SubAvatarContent } from "@skailer-com/uikit";
import { useMemo } from "react";

export interface EmployeeAvatarProps {
  employee: ApiEmployeeShort;
  size?: keyof AvatarSizes;
  variant?: AvatarVariant;
  subAvatar?: SubAvatarContent;
  onLoad?: () => void;
  className?: string;
}

const avatarSizeToUrlSizeMap: Record<keyof AvatarSizes, "sm" | "md" | "lg" | "4xl"> = {
  xs: "sm",
  sm: "sm",
  md: "md",
  lg: "md",
  xl: "md",
  "2xl": "4xl",
  "4xl": "4xl",
};

export const EmployeeAvatar = ({
  employee,
  size,
  onLoad,
  variant,
  subAvatar,
  className,
}: EmployeeAvatarProps) => {
  const { renderEmployeeName } = useFormatter();

  const acronym = useMemo(() => {
    return getNameInitials(renderEmployeeName(employee));
  }, [employee, renderEmployeeName]);

  return (
    <Avatar
      url={getEmployeeAvatarUrl(employee, size ? avatarSizeToUrlSizeMap[size] : "md")}
      size={size}
      onLoad={onLoad}
      acronym={acronym}
      variant={variant}
      subAvatar={subAvatar}
      className={className}
    />
  );
};
